export default __webpack_public_path__ + "static/media/undraw_Website_setup_re_d4y9.96934265.svg";